import { render, staticRenderFns } from "./search-sort-selector.vue?vue&type=template&id=dfdc998a"
import script from "./search-sort-selector.vue?vue&type=script&lang=js"
export * from "./search-sort-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports